import React from "react";

import BlogReview from "../features/wordpress/platforms/wordpress/components/BlogReview";
import { useCustomerWorkspace } from "../context/CustomerWorkspaceContext";

interface BlogsPageProps {
  /**
   * When embedded inside the Content hub (SocialPostsPageV2), the hub already
   * supplies the page header, business pill, and card shell — so render only the
   * BlogReview list. Standalone, render the full page chrome. Mirrors ConnectPage.
   */
  embedded?: boolean;
}

/**
 * Blogs page — the blog counterpart of the "Manage Social Media" review page.
 * Hosts the BlogReview list so customers can review and edit their saved blogs.
 * Reused (not duplicated) by the Content hub via the `embedded` prop.
 */
const BlogsPage: React.FC<BlogsPageProps> = ({ embedded = false }) => {
  const { selectedCustomerName } = useCustomerWorkspace();

  if (embedded) {
    return <BlogReview />;
  }

  return (
    <div className="p-6">
      <div className="mx-auto max-w-[1130px] space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-theme-fg">Manage Blogs</h1>
            {selectedCustomerName && (
              <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700 shadow-sm ring-1 ring-inset ring-green-600/20 transition-all hover:bg-green-100 dark:bg-green-900/20 dark:text-green-400 dark:ring-green-500/20 dark:hover:bg-green-900/40">
                <span className="material-icons-outlined text-[18px] text-amber-600 opacity-90 dark:text-amber-500">
                  storefront
                </span>
                <span>{selectedCustomerName}</span>
              </div>
            )}
          </div>
        </div>

        <div className="rounded-md border border-theme-border bg-theme-surface p-6 shadow-sm">
          <BlogReview />
        </div>
      </div>
    </div>
  );
};

export default BlogsPage;
